import Qs from 'qs'
// 下载方法
export function downloadA (downloadPath = '', params) {
  if (params) {
    let str = Qs.stringify(params)
    downloadPath = downloadPath + '?' + str
  }
  let aTag = document.createElement('a')
  document.body.appendChild(aTag)
  aTag.href = downloadPath
  aTag.target = '_blank'
  aTag.click()
  aTag.remove()
}
// 按钮权限控制
export function AuthClient (menus, resId) {
  let result = false
  if (!menus || menus.length <= 0) {
    return false
  }
  function findResourceId (menus, resId) {
    menus.map(item => {
      if (item.resId == resId) {
        result = true
        return
      }
      if (item.children) {
        findResourceId(item.children, resId)
      }
    })
  }
  findResourceId(menus, resId)
  return result
}

export function urlByEnvFn () {
  let isTestEnv = process.env.NODE_ENV === 'development'
  let hostPre = '//' + (isTestEnv ? 'test.' : '')
  let yscHost = hostPre + 'ysc.jd.com'

  return {
    fwUrl: '//fw.jd.com/772005.html',
    host: yscHost,
    ssoHome: hostPre + 'ssa.jd.com/sso/login?ReturnUrl=' + yscHost + '/authc/forwardHome',
    passwordHome: '//passport.jd.com/new/login.aspx?ReturnUrl=' + yscHost + '/authc/forwardHome'
  }
}
